// // // import React from "react";
// // // import "./WhatWeDo.css";

// // // const WhatWeDo = () => {
// // //   const categories = [
// // //     {
// // //       title: "accounts",
// // //       icon: "fas fa-file-invoice-dollar",
// // //       items: [
// // //         "Statutory Accounts",
// // //         "Management",
// // //         "Bookkeeping",
// // //         "Internal Audit",
// // //       ],
// // //     },
// // //     {
// // //       title: "taxation",
// // //       icon: "fas fa-calculator",
// // //       items: [
// // //         "Tax Returns",
// // //         "VAT",
// // //         "Payroll",
// // //         "Tax Registration",
// // //         "Tax Residency",
// // //       ],
// // //     },
// // //     {
// // //       title: "business set-up",
// // //       icon: "fas fa-chart-line",
// // //       items: [
// // //         "Franchise Setup",
// // //         "Business Valuation",
// // //         "Business Planning",
// // //         "Business Start-ups",
// // //         "Business Advisory",
// // //         "Citizenship/residence by investment",
// // //       ],
// // //     },
// // //     {
// // //       title: "corporate services",
// // //       icon: "fas fa-briefcase",
// // //       items: [
// // //         "Incorporations",
// // //         "Redomiciliation",
// // //         "Fiduciary Services",
// // //         "Company Secretarial Services",
// // //         "Ship/Yacht and Aircraft Registration",
// // //       ],
// // //     },
// // //     {
// // //       title: "corporate structuring",
// // //       icon: "fas fa-sitemap",
// // //       items: [
// // //         "Reorganisation/Restructuring",
// // //         "Cross Border Tax Structure",
// // //         "Merger and Acquisition",
// // //         "Holding Companies",
// // //         "Agency and Asset holding companies",
// // //         "IP and Royalty Structures",
// // //         "Relocation and migration services",
// // //       ],
// // //     },
// // //     {
// // //       title: "umbrella/contracting services",
// // //       icon: "fas fa-umbrella",
// // //       items: [
// // //         "We provide umbrella company, umbrella director and private company limited services for Doctors who does contracting.",
// // //         "We provide Umbrella Company and Umbrella Director Service for IT contractors.",
// // //       ],
// // //     },
// // //   ];

// // //   return (
// // //     <section className="what-we-do section bg-white" id="what-we-do">
// // //       <div className="container">
// // //         <h2 className="section-title">what we do</h2>
// // // <p className="section-intro">
// // //   Your finances are in safe hands with our reliable, flexible and
// // //   cost-effective bookkeeping and Irish accounts, tax and corporate
// // //   services.
// // // </p>

// // //         <div className="services-categories">
// // //           {categories.map((category, index) => (
// // //             <div key={index} className="category">
// // //               <h3 className="category-title">
// // //                 <i className={`${category.icon} category-icon`}></i>
// // //                 {category.title}
// // //               </h3>
// // //               <ul className="category-list">
// // //                 {category.items.map((item, itemIndex) => (
// // //                   <li key={itemIndex}>{item}</li>
// // //                 ))}
// // //               </ul>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default WhatWeDo;

// // import React, { useState } from "react";
// // import "./WhatWeDo.css";

// // const WhatWeDo = () => {
// //   const [activeCard, setActiveCard] = useState(null);

// //   const categories = [
// //     {
// //       title: "Accounts",
// //       icon: "fas fa-file-invoice-dollar",
// //       items: [
// //         "Statutory Accounts",
// //         "Management",
// //         "Bookkeeping",
// //         "Internal Audit",
// //       ],
// //     },
// //     {
// //       title: "Taxation",
// //       icon: "fas fa-calculator",
// //       items: [
// //         "Tax Returns",
// //         "VAT",
// //         "Payroll",
// //         "Tax Registration",
// //         "Tax Residency",
// //       ],
// //     },
// //     {
// //       title: "Business Set-Up",
// //       icon: "fas fa-chart-line",
// //       items: [
// //         "Franchise Setup",
// //         "Business Valuation",
// //         "Business Planning",
// //         "Business Start-ups",
// //         "Business Advisory",
// //         "Citizenship/residence by investment",
// //       ],
// //     },
// //     {
// //       title: "Corporate Services",
// //       icon: "fas fa-briefcase",
// //       items: [
// //         "Incorporations",
// //         "Redomiciliation",
// //         "Fiduciary Services",
// //         "Company Secretarial Services",
// //         "Ship/Yacht and Aircraft Registration",
// //       ],
// //     },
// //     {
// //       title: "Corporate Structuring",
// //       icon: "fas fa-sitemap",
// //       items: [
// //         "Reorganisation/Restructuring",
// //         "Cross Border Tax Structure",
// //         "Merger and Acquisition",
// //         "Holding Companies",
// //         "Agency and Asset holding companies",
// //         "IP and Royalty Structures",
// //         "Relocation and migration services",
// //       ],
// //     },
// //   ];

// //   const toggleCard = (index) => {
// //     setActiveCard(index === activeCard ? null : index);
// //   };

// //   return (
// //     <section className="what-we-do section" id="what-we-do">
// //       <div className="container">
// //         <h2 className="section-title">What We Do</h2>
// //         <p className="section-intro">
// //           Your finances are in safe hands with our reliable, flexible and
// //           cost-effective bookkeeping and Irish accounts, tax and corporate
// //           services.
// //         </p>

// //         <div className="services-grid">
// //           {categories.map((category, index) => {
// //             const isActive = index === activeCard;

// //             return (
// //               <div
// //                 key={index}
// //                 className={`service-card ${isActive ? "active" : ""}`}
// //                 onClick={() => toggleCard(index)}
// //               >
// //                 <div className="service-header">
// //                   <div className="service-icon">
// //                     <i className={category.icon}></i>
// //                   </div>

// //                   <h3>{category.title}</h3>

// //                   <span className="expand-icon">{isActive ? "-" : "+"}</span>
// //                 </div>

// //                 <ul className={`service-list ${isActive ? "show" : ""}`}>
// //                   {category.items.map((item, i) => (
// //                     <li key={i}>{item}</li>
// //                   ))}
// //                 </ul>
// //               </div>
// //             );
// //           })}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default WhatWeDo;

// import React, { useState } from "react";
// import "./WhatWeDo.css";

// const WhatWeDo = () => {
//   const [activeCard, setActiveCard] = useState(null);

//   const categories = [
//     {
//       title: "Accounts",
//       icon: "fas fa-file-invoice-dollar",
//       items: [
//         "Statutory Accounts",
//         "Management",
//         "Bookkeeping",
//         "Internal Audit",
//       ],
//     },
//     {
//       title: "Taxation",
//       icon: "fas fa-calculator",
//       items: [
//         "Tax Returns",
//         "VAT",
//         "Payroll",
//         "Tax Registration",
//         "Tax Residency",
//       ],
//     },
//     {
//       title: "Business Set-Up",
//       icon: "fas fa-chart-line",
//       items: [
//         "Franchise Setup",
//         "Business Valuation",
//         "Business Planning",
//         "Business Start-ups",
//         "Business Advisory",
//         "Citizenship/residence by investment",
//       ],
//     },
//     {
//       title: "Corporate Services",
//       icon: "fas fa-briefcase",
//       items: [
//         "Incorporations",
//         "Redomiciliation",
//         "Fiduciary Services",
//         "Company Secretarial Services",
//         "Ship/Yacht and Aircraft Registration",
//       ],
//     },
//     {
//       title: "Corporate Structuring",
//       icon: "fas fa-sitemap",
//       items: [
//         "Reorganisation/Restructuring",
//         "Cross Border Tax Structure",
//         "Merger and Acquisition",
//         "Holding Companies",
//         "Agency and Asset holding companies",
//         "IP and Royalty Structures",
//         "Relocation and migration services",
//       ],
//     },
//     {
//       title: "Umbrella / Contracting Services",
//       icon: "fas fa-umbrella",
//       items: [
//         "We provide umbrella company, umbrella director and private company limited services for Doctors who does contracting.",
//         "We provide Umbrella Company and Umbrella Director Service for IT contractors.",
//       ],
//     },
//   ];

//   const toggleCard = (index) => {
//     if (activeCard === index) {
//       setActiveCard(null);
//     } else {
//       setActiveCard(index);
//     }
//   };

//   return (
//     <section className="what-we-do section" id="what-we-do">
//       <div className="container">
//         <h2 className="section-title">What We Do</h2>

//         <p className="section-intro">
//           Your finances are in safe hands with our reliable, flexible and
//           cost-effective bookkeeping and Irish accounts, tax and corporate
//           services.
//         </p>

//         <div className="services-grid">
//           {categories.map((category, index) => {
//             const isOpen = activeCard === index;

//             return (
//               <div
//                 key={index}
//                 className={`service-card ${isOpen ? "active" : ""}`}
//                 onClick={() => toggleCard(index)}
//               >
//                 <div className="service-header">
//                   <div className="service-icon">
//                     <i className={category.icon}></i>
//                   </div>

//                   <h3>{category.title}</h3>

//                   <span className="expand-icon">{isOpen ? "−" : "+"}</span>
//                 </div>

//                 <ul className={`service-list ${isOpen ? "show" : ""}`}>
//                   {category.items.map((item, i) => (
//                     <li key={i}>{item}</li>
//                   ))}
//                 </ul>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhatWeDo;

// import React, { useState, useRef } from "react";
import React from "react";
import heroImage from "../../images/hnutax.png";
import "../Hero/Hero.css";
import "./WhatWeDo.css";

const WhatWeDo = () => {
  // const [activeCard, setActiveCard] = useState(null);
  // const cardRefs = useRef([]);

  // const categories = [
  //   {
  //     title: "Accounts",
  //     icon: "fas fa-file-invoice-dollar",
  //     items: [
  //       "Statutory Accounts",
  //       "Management",
  //       "Bookkeeping",
  //       "Internal Audit",
  //     ],
  //   },
  //   {
  //     title: "Taxation",
  //     icon: "fas fa-calculator",
  //     items: [
  //       "Tax Returns",
  //       "VAT",
  //       "Payroll",
  //       "Tax Registration",
  //       "Tax Residency",
  //     ],
  //   },
  //   {
  //     title: "Business Set-Up",
  //     icon: "fas fa-chart-line",
  //     items: [
  //       "Franchise Setup",
  //       "Business Valuation",
  //       "Business Planning",
  //       "Business Start-ups",
  //       "Business Advisory",
  //       "Citizenship/residence by investment",
  //     ],
  //   },
  //   {
  //     title: "Corporate Services",
  //     icon: "fas fa-briefcase",
  //     items: [
  //       "Incorporations",
  //       "Redomiciliation",
  //       "Fiduciary Services",
  //       "Company Secretarial Services",
  //     ],
  //   },
  //   {
  //     title: "Corporate Structuring",
  //     icon: "fas fa-sitemap",
  //     items: [
  //       "Reorganisation/Restructuring",
  //       "Cross Border Tax Structure",
  //       "Merger and Acquisition",
  //       "Holding Companies",
  //       "Agency and Asset holding companies",
  //       "IP and Royalty Structures",
  //       "Relocation and migration services",
  //     ],
  //   },
  // ];

  // const toggleCard = (index) => {
  //   const newIndex = activeCard === index ? null : index;
  //   setActiveCard(newIndex);

  //   if (newIndex !== null) {
  //     setTimeout(() => {
  //       cardRefs.current[newIndex]?.scrollIntoView({
  //         behavior: "smooth",
  //         block: "center",
  //       });
  //     }, 200);
  //   }
  // };

  return (
    <section className="what-we-do section" id="about-us">
      <div className="container">
        <h2 className="section-title">about Us</h2>

        <p className="section-intro">
          HNU Accounting LTD is a Dublin-based professional accounting and
          business services practice founded by experienced finance
          professionals with over five years of combined expertise across
          accounting, taxation, financial reporting, and regulatory compliance.
          We support individuals, self-employed professionals, SMEs, and growing
          enterprises by delivering accurate, efficient, and commercially
          focused financial solutions designed to strengthen financial
          management and business performance.
        </p>

        {/* <div className="services-grid">
          {categories.map((category, index) => {
            const isOpen = activeCard === index;

            return (
              <div
                key={index}
                ref={(el) => (cardRefs.current[index] = el)}
                className={`service-card ${isOpen ? "active" : ""}`}
                onClick={() => toggleCard(index)}
              >
                <div className="service-header">
                  <div className="service-icon">
                    <i className={category.icon}></i>
                  </div>

                  <h3>{category.title}</h3>

                  <div className={`expand-icon ${isOpen ? "rotate" : ""}`}>
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>

                <ul className={`service-list ${isOpen ? "show" : ""}`}>
                  {category.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div> */}

        <div className="container what-we-do-grid">
          {/* LEFT IMAGE */}
          <div className="what-we-do-content">
            {/* <h1 className="hero-title">Accounting with Lasting Success</h1> */}

            <p className="what-we-do-subtitle">
              Our services include bookkeeping, payroll administration, VAT
              compliance, Revenue submissions, management accounts, statutory
              financial statements, tax compliance, and company secretarial
              obligations. With a strong foundation in accounting principles and
              a practical understanding of business operations, we provide
              dependable financial support that enables clients to maintain
              compliance, enhance financial visibility, and make informed
              decisions with confidence.
            </p>
          </div>

          {/* RIGHT CONTENT */}

          <div className="what-we-do-image">
            <img src={heroImage} alt="Accounting Illustration" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
